import { fromJS } from 'immutable'
import MAP_STYLE from './style'

export const defaultMapStyle = fromJS(MAP_STYLE)
